/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import template, { templateSimpleDropdown } from './template.html';

/* 
  <select>
    <optgroup label="Group 1">
      <option>Option 1.1</option>
    </optgroup> 
    <optgroup label="Group 2">
      <option>Option 2.1</option>
      <option>Option 2.2</option>
    </optgroup>
    <optgroup label="Group 3" disabled>
      <option>Option 3.1</option>
      <option>Option 3.2</option>
      <option>Option 3.3</option>
    </optgroup>
  </select>


  có data description trong từng item
*/

/* 
  Thêm simple Dropdown
  <ul name="more-settings">
    <li value="rename" data-icon="pen">Rename</li>
    <li value="duplicate" data-icon="dupilcate">Duplicate</li>
    <li value="queue" data-icon="queue">Queue Action <span class="turn-onoff"><span class="on">On</span><span class="off">Off</span></span></li>
    <li value="delete" data-icon="delete">Delete</li>
  </ul>

  có data description trong từng item
*/

/**
 * DropdownControl
 */
export default class DropdownGroupControl {
  $input: JQuery;
  $wrapper: JQuery;
  options: any;
  $html: JQuery;
  name: string;
  $dropdownGroup: JQuery;
  $dropdownDescription: JQuery;
  defaultDescription: string;

  flagClickOpen = false;
  animationSpeed = 300;

  /**
   * constructor
   * @param $input ..
   * @param options ..
   */
  constructor($input: JQuery, options?: any) {
    this.$input = $input;
    this.$wrapper = $input.parent();
    this.options = options;
    this.renderTemplate();
    this.name = $input.attr('name') || '';

    this.animationSpeed = this.options?.animationSpeed || 300;
  }

  /**
   * Toggle Dropdown
   */
  toggle(): void {
    if (this.$dropdownGroup.is(':visible')) {
      this.close();
    } else {
      this.open();
    }
  }
  /**
   * Open Dropdown
   */
  open(): void {
    this.$dropdownGroup.slideDown(this.animationSpeed);
    this.flagClickOpen = true;
    this.refreshScroll();

    if (this.options && this.options.onOpened) {
      this.options.onOpened();
    }
  }

  /**
   * close Dropdown
   */
  close(): void {
    this.$dropdownGroup.slideUp(this.animationSpeed);
    this.flagClickOpen = false;

    if (this.options && this.options.onClosed) {
      this.options.onClosed();
    }
  }

  /**
   * Render Select to Template
   * @returns void
   */
  renderTemplate(): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;

    this.$input.hide();

    if (this.options.type && this.options.type == 'simple') {
      const html = templateSimpleDropdown(this.$input);
      this.$html = $(html);
      this.$dropdownGroup = this.$html.find('.dropdown-group');
      this.applySimpleEvents();
    } else {
      const html = template(this.$input);
      this.$html = $(html);
      this.$dropdownGroup = this.$html.find('.dropdown-group');
      this.$dropdownDescription = this.$html.find('.dropdown-description');
      if (this.options.enableDescription) {
        this.defaultDescription = this.$dropdownDescription.text();
      } else {
        this.$dropdownDescription.hide(0);
      }
      this.applyEvents();
    }

    jQuery(window).on('click.outside', function (event) {
      if (_this.flagClickOpen) {
        _this.flagClickOpen = false;
        return;
      }
      if (_this.$dropdownGroup.is(':visible')) {
        if (!$(event.target).closest(_this.$html).length && !$(event.target).is(_this.$html)) {
          _this.close();

          if (_this.options && _this.options.onClosed) {
            _this.options.onClosed();
          }
        }
      }
    });

    this.$html
      .find('.option-item')
      .off('click')
      .on('click', function () {
        const value = $(this).data('value') || '';
        const text = $(this).text() || '';

        const data = {
          name: _this.name,
          value: value,
          text: text,
        };

        _this.setValue(value);

        if (_this.options && _this.options.onChange) {
          _this.options.onChange(data);
        }

        _this.close();
      });

    (this.$html.find('.gf-dropdown-list').addClass('optiscroll') as any).optiscroll();
    this.$input.after(this.$html);

    this.refreshScroll();
  }

  /**
   * applyEvents
   */
  applyEvents(): void {
    const _this = this;
    const $wrap = this.$html.find('.optgroup-wrap');
    this.$html
      .find('.optgroup-label')
      .off('click')
      .on('click', function () {
        const $currentWrap = jQuery(this).closest('.optgroup-wrap');

        $wrap.each(function () {
          if (jQuery(this).is($currentWrap)) {
            if (jQuery(this).hasClass('active')) {
              jQuery(this).removeClass('active').children('ul').stop(true, false).slideUp(_this.animationSpeed);
            } else {
              jQuery(this)
                .addClass('active')
                .children('ul')
                .stop(true, false)
                .slideDown(_this.animationSpeed, function () {
                  _this.refreshScroll();
                });
            }
          } else {
            jQuery(this).removeClass('active').children('ul').stop(true, false).slideUp(_this.animationSpeed);
          }
        });

        /* if ($currentWrap.hasClass("active")) {
        $wrap.removeClass("active").stop(true, false).slideUp(300);
      } else {
        
        $wrap.removeClass("active");
        $currentWrap.addClass("active");
        $currentWrap.slideDown();
      } */
      });

    if (this.options.enableDescription) {
      this.$html
        .find('.optgroup-label, .option-item')
        .off('mouseenter')
        .on('mouseenter', function () {
          const description = jQuery(this).attr('data-description') || _this.defaultDescription;
          _this.$dropdownDescription.text(description);
        });

      this.$html
        .find('.optgroup-label, .option-item')
        .off('mouseenter')
        .on('mouseenter', function () {
          const description = jQuery(this).attr('data-description') || _this.defaultDescription;
          _this.$dropdownDescription.text(description);
        });

      this.$html.off('mouseleave').on('mouseleave', function () {
        _this.$dropdownDescription.text(_this.defaultDescription);
      });
    }

    //add default active
    if (!this.$html.find('.active').length) {
      this.$html.find('.optgroup-wrap').first().addClass('active').find('ul').first().css('display', 'block');
    }
  }

  /**
   * applySimpleEvents
   */
  applySimpleEvents(): void {
    /* const _this = this;
    const $wrap = this.$html.find(".optgroup-wrap");
    this.$html.find(".optgroup-label").off("click").on("click", function () {
      const $currentWrap = jQuery(this).closest(".optgroup-wrap");
      if ($currentWrap.hasClass("active")) {
        $wrap.removeClass("active");
      } else {
        $wrap.removeClass("active");
        $currentWrap.addClass("active");
      }
    });

    this.$html.find(".optgroup-label, .option-item").off("mouseenter").on("mouseenter", function () {
      const description = jQuery(this).attr("data-description") || _this.defaultDescription;
      _this.$dropdownDescription.text(description);
    });

    this.$html.find(".optgroup-label, .option-item").off("mouseenter").on("mouseenter", function () {
      const description = jQuery(this).attr("data-description") || _this.defaultDescription;
      _this.$dropdownDescription.text(description);
    });

    this.$html.off("mouseleave").on("mouseleave", function () {
      _this.$dropdownDescription.text(_this.defaultDescription);
    });

    

    //add default active
    if (!this.$html.find(".active").length) {
      this.$html.find(".optgroup-label")[0].click();
    } */
  }

  /**
   * refreshScroll
   */
  refreshScroll(): void {
    this.$html.find('.active ul:not(.optiscroll)').each(function () {
      const height = jQuery(this).height() || 0;
      if (height > 240) {
        jQuery(this).css('height', '240px');
        (jQuery(this).addClass('optiscroll') as any).optiscroll();
      }
    });
  }

  /**
   * Set value to select
   * @param value ..
   * @returns void
   */
  setValue(value: string | number): void {
    this.$input.val(value);
  }

  /**
   * Set value to select
   * @returns .
   */
  getValue(): any {
    return this.$input.val();
  }
}
